import { Link } from "react-router-dom";
import NoticeComponent from "../../components/NoticeComponent";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { noticeList } from "../../data/NoticeData";
import { useMediaQuery } from "react-responsive";

export default function Notice() {
  const { t } = useTranslation(); // useTranslation 사용
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [openId, setOpenId] = useState<number | null>(null);
  const [activeSection, setActiveSection] = useState<string | null>(null);

  const itemsPerPage = 10;

  // 필터링된 공지사항 목록
  const filteredNotices = noticeList.filter((notice) =>
    notice.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // 페이지네이션을 위한 시작 및 끝 인덱스 계산
  const indexOfLastNotice = currentPage * itemsPerPage;
  const indexOfFirstNotice = indexOfLastNotice - itemsPerPage;

  const currentNotices = filteredNotices.slice(
    indexOfFirstNotice,
    indexOfLastNotice
  );

  // 총 페이지 수 계산
  const totalPages = Math.ceil(filteredNotices.length / itemsPerPage);

  const handlePageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  const isMobile = useMediaQuery({ maxWidth: 767 });

  return (
    <div className="mt-[130px] h-screen max-w-[1440px] w-full mx-auto mobile:px-4">
      <NoticeComponent
        title={t('notice.title')}
        content={
          isMobile ? (
            <>
              최신 소식과 중요한 안내사항을 확인하세요.
              <br />
              필요한 정보를 빠르게 제공해드립니다.
            </>
          ) : (
            '최신 소식과 중요한 안내사항을 확인하세요. 필요한 정보를 빠르게 제공해드립니다.'
          )
        }
      />
      <div className="mb-4">
        <input
          type="text"
          placeholder={t('notice.search')} // 검색 다국어 지원
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full h-[55px] mobile:h-[44px] py-2 pl-4 border-[#e2e2e2] border tracking-wide text-[#1f1f1f] placeholder:text-[#afafaf] mobile:text-[13px] text-base mt-4 mobile:mt-2 rounded-md"
        />
      </div>
      <ul className="space-y-8 mobile:space-y-[8px] mt-6 mobile:mt-1">
        {currentNotices.length > 0 ? (
          currentNotices.map((notice) => (
            <li
              key={notice.id}
              className="flex justify-between items-center border-b py-4 mobile:py-2"
            >
              <Link
                to={`/notice/${notice.id}`}
                className="text-lg mobile:text-[13px] text-[#111] Pretendard-Medium hover:underline text-nowrap mobile:overflow-hidden mobile:text-ellipsis mobile:w-[200px]"
              >
                {notice.title}
              </Link>
              <span className="text-[#afafaf] mobile:text-xs Pretendard-Regular">{notice.date}</span>
            </li>
          ))
        ) : (
          <li className="text-center text-gray-500">
            {t('notice.no_notices')}
          </li>
        )}
      </ul>
      <div className="flex justify-center items-center mt-[200px] space-x-4">
        <button
          disabled={currentPage === 1}
          onClick={() => handlePageChange(currentPage - 1)}
          className={`px-3 py-1 border rounded cursor-pointer  ${
            currentPage === 1 ? 'text-gray-400' : 'text-blue-600'
          }`}
        >
          {t('notice.previous')}
        </button>
        {Array.from({ length: totalPages }, (_, index) => (
          <button
            key={index}
            onClick={() => handlePageChange(index + 1)}
            className={`px-3 py-1 border rounded ${
              currentPage === index + 1
                ? 'bg-blue-500 text-white'
                : 'text-blue-600'
            }`}
          >
            {index + 1}
          </button>
        ))}
        <button
          disabled={currentPage === totalPages}
          onClick={() => handlePageChange(currentPage + 1)}
          className={`px-3 py-1 border rounded cursor-pointer  ${
            currentPage === totalPages ? 'text-gray-400' : 'text-blue-600'
          }`}
        >
          {t('notice.next')}
        </button>
      </div>
    </div>
  );
}